
<template>
  <div>
    <!-- {{consolidation}} -->
    <div class="title">Resumo</div>
    <v-card flat style="border-radius:12px">
      <v-card-text v-if="consolidation">
        <div>
          <span class="font-weight-bold">
            Nome: 
          </span>
          <span>{{execution.name}}</span>
        </div>
        <div>
          <span class="font-weight-bold">
            Modelo: 
          </span>
          <span>2- Por Categorias</span>
        </div>
        <div>
          <span class="font-weight-bold">
            Data e período: 
          </span>
          <span>{{$dayjs(execution.date).format('DD/MM/YYYY')}}, {{consolidation.job_interval.start}} - {{consolidation.job_interval.end}}</span>
        </div>
        <div>
          <span class="font-weight-bold">
            Departamento: 
          </span>
          <span>{{execution.dep_name}}</span>
        </div>
        <div>
          <span class="font-weight-bold">
            Pessoas avaliadas: 
          </span>
          <span>{{items[items.length-1].total}}</span>
        </div>
      </v-card-text>
    </v-card>
    <v-tabs
      v-model="tab"
      centered
      grow
      icons-and-text
      show-arrows
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab>
        Tabela
        <v-icon>mdi-table-large</v-icon>
      </v-tab>

      <v-tab>
        Indicadores
        <v-icon>mdi-chart-arc</v-icon>
      </v-tab>

      <v-tab>
        Pareto
        <v-icon>mdi-chart-line</v-icon>
      </v-tab>

      <v-tab>
        Comentários
        <v-icon>mdi-chat</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :value="0">
        <list-table v-if="tab==0" :headers='headers' :items='items'></list-table>
      </v-tab-item>
      <v-tab-item :value="1">
        <indicators v-if="tab==1" :total_by_cat='total_by_cat' :items='items'></indicators>
      </v-tab-item>
      <v-tab-item :value="2">
        <pareto v-if="tab==2" :total_by_cat='total_by_cat' :items='items'></pareto>
      </v-tab-item>
      <v-tab-item :value="3">
        <comments v-if="tab==3" :comments='comments'></comments>
      </v-tab-item>
    </v-tabs-items>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Comments from '../shared/Comments.vue'
import Indicators from '../shared/Indicators.vue'
import Pareto from '../shared/Pareto.vue'

export default {
  name: 'ConsolidationModel2',
  props: {
    execution: {
      type: Object,
    },
  },
  components: {
    ListTable: ()=> import('./Model2Table.vue'),
    Pareto,
    Indicators,
    Comments,
  },
  data() {
    return {
      tab: 1, 

      consolidation: null,
      categories: [],
      times_and_grades: [],
      total_by_cat: [],
    }
  },
  methods: {
    prepareConsolidation() {
      this.consolidation = { ...this.execution.json_attributes}
      this.setCategories()

      this.setTimesAndGrades()

      this.setTotalByCat()

      this.addTotalToTimesAndGrades()

      this.setTotalByCatPercent()
      
    },
    setCategories(){
      this.categories = this.consolidation.categories.map(cat=> {
        let {grade_time, ...c} = cat
        return c
      })
    },
    setTimesAndGrades(){
      this.times_and_grades = []
      for (let idx = 0; idx < this.consolidation.all_times.length; idx++) {
        const tempo = this.consolidation.all_times[idx];
        let obj = {
          time: tempo,
        }
        for (let cat = 0; cat < this.consolidation.categories.length; cat++) {
          const el = this.consolidation.categories[cat];
          obj = {
            ...obj,
            [el.id]: el.grade_time[idx]
          }
        }
        let {time, ...o} = obj
        let total = Object.values(o).reduce((one, all)=> Number(one)+all, 0)
        this.times_and_grades.push({...obj, total})
      }
    },
    setTotalByCat(){
      this.total_by_cat = this.consolidation.categories.map(cat=>{
        let {id, grade_time, ...c}= cat
        let obj = {
          time: 'Total',
          id,
          sum: grade_time.reduce((one, all)=> Number(one)+all, 0),
          ...c
        }
        return obj
      })
      
    },
    addTotalToTimesAndGrades(){
      let by_cat = {}
      for (let idx = 0; idx < this.total_by_cat.length; idx++) {
        const element = this.total_by_cat[idx];
        by_cat[element.id] = element.sum
      }
      let t = Object.values(by_cat).reduce((one, all)=> Number(one)+all, 0)
      by_cat = {
        time: 'Total',
        ...by_cat,
        total: t
      }

      this.times_and_grades.push(by_cat)
    },
    setTotalByCatPercent(){
      let total = this.total_by_cat.reduce((acc, one) => Number(one.sum) + acc, 0)
      this.total_by_cat = this.total_by_cat.map(cat => {
        let percent = Number((cat.sum/total*100).toFixed(1))
        return {
          ...cat, percent
        }
      })
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.prepareConsolidation();
  },
  computed: {
    items(){
      if (this.consolidation && this.times_and_grades.length){
        return this.times_and_grades
      }
      return []
    },
    headers(){
      if (this.consolidation){
        let cat_h = this.categories.map(cat=> {
          let {name, id, code, kind} = cat
          return {kind, code, text: `${code}- ${name.split('COMPLEMENTAR - ').pop()}`, value: id.toString()}
        })
        let headers = [
          {text: 'Hora', value: 'time'},
          ...cat_h,
          {text: 'Total', value: 'total'},
        ]
        return headers
      }
      return []
    },
    comments() {
      if (this.consolidation){
        return this.consolidation.comments || []
      }
      return [] 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>